import { createI18n } from 'vue-i18n'

import esCommon from '@/locales/es/common.json'
import esAuth from '@/locales/es/auth.json'
import esNav from '@/locales/es/nav.json'
import esSettings from '@/locales/es/settings.json'
import esBilling from '@/locales/es/billing.json'
import esHome from '@/locales/es/home.json'
import esMyTasks from '@/locales/es/mytasks.json'
import esDashboard from '@/locales/es/dashboard.json'
import esErrors from '@/locales/es/errors.json'
import esMeta from '@/locales/es/meta.json'
import esNotifications from '@/locales/es/notifications.json'
import esTask from '@/locales/es/task.json'
import esTags from '@/locales/es/tags.json'
import esTeam from '@/locales/es/team.json'
import esReports from '@/locales/es/reports.json'
import esPortfolio from '@/locales/es/portfolio.json'
import esActivity from '@/locales/es/activity.json'
import esMeetings from '@/locales/es/meetings.json'
import esProject from '@/locales/es/project.json'
import esDepartments from '@/locales/es/departments.json'
import esAi from '@/locales/es/ai.json'
import esOnboarding from '@/locales/es/onboarding.json'
import esLanding from '@/locales/es/landing.json'
import esPortal from '@/locales/es/portal.json'

import enCommon from '@/locales/en/common.json'
import enAuth from '@/locales/en/auth.json'
import enNav from '@/locales/en/nav.json'
import enSettings from '@/locales/en/settings.json'
import enBilling from '@/locales/en/billing.json'
import enHome from '@/locales/en/home.json'
import enMyTasks from '@/locales/en/mytasks.json'
import enDashboard from '@/locales/en/dashboard.json'
import enErrors from '@/locales/en/errors.json'
import enMeta from '@/locales/en/meta.json'
import enNotifications from '@/locales/en/notifications.json'
import enTask from '@/locales/en/task.json'
import enTags from '@/locales/en/tags.json'
import enTeam from '@/locales/en/team.json'
import enReports from '@/locales/en/reports.json'
import enPortfolio from '@/locales/en/portfolio.json'
import enActivity from '@/locales/en/activity.json'
import enMeetings from '@/locales/en/meetings.json'
import enProject from '@/locales/en/project.json'
import enDepartments from '@/locales/en/departments.json'
import enAi from '@/locales/en/ai.json'
import enOnboarding from '@/locales/en/onboarding.json'
import enLanding from '@/locales/en/landing.json'
import enPortal from '@/locales/en/portal.json'

const messages = {
  es: {
    common: esCommon, auth: esAuth, nav: esNav, settings: esSettings,
    billing: esBilling, home: esHome, mytasks: esMyTasks, dashboard: esDashboard,
    errors: esErrors, meta: esMeta, notifications: esNotifications, task: esTask,
    tags: esTags, team: esTeam, reports: esReports, portfolio: esPortfolio, activity: esActivity, meetings: esMeetings, project: esProject,
    departments: esDepartments, ai: esAi, onboarding: esOnboarding, landing: esLanding, portal: esPortal,
  },
  en: {
    common: enCommon, auth: enAuth, nav: enNav, settings: enSettings,
    billing: enBilling, home: enHome, mytasks: enMyTasks, dashboard: enDashboard,
    errors: enErrors, meta: enMeta, notifications: enNotifications, task: enTask,
    tags: enTags, team: enTeam, reports: enReports, portfolio: enPortfolio, activity: enActivity, meetings: enMeetings, project: enProject,
    departments: enDepartments, ai: enAi, onboarding: enOnboarding, landing: enLanding, portal: enPortal,
  },
}

export const i18n = createI18n({
  legacy: false,
  locale: 'es',
  fallbackLocale: 'es',
  messages,
  globalInjection: true,
  missingWarn: false,
  fallbackWarn: false,
})

export type SupportedLocale = keyof typeof messages
